import { createApp } from 'vue'
import DaysBetweenDates from './DaysBetweenDates.vue'
import './assets/global.css'

createApp(DaysBetweenDates).mount('#days-between-dates')
